import { Avatar, Box, IconButton, MenuItem, styled } from "@mui/material";
import useLogout from "@lib/user/useLogout";
import { useState } from "react";
import { useRouter } from "next/navigation";
import ContextMenu from "@components/shared/ContextMenu";
import Settings from "./Settings";
import config from "@lib/config";
import { useAuth } from "@/hooks/useAuth";
import { createPortalSession } from "@lib/api/billing";
import { useSettingsDialog } from "@lib/settings/SettingsDialogContext";

const ProfileContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  columnGap: "1rem",
});

const StyledMenuItem = styled(MenuItem)({
  "&&": {
    justifyContent: "flex-start",
  },
});

const UserDetails = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  rowGap: "0.5rem",
  borderBottom: "1px solid #131313",
  padding: "18px",
  span: {
    fontSize: "0.8rem",
  },
});

export default function UserProfile({ recruiter, isAdmin }) {
  const logout = useLogout();
  const router = useRouter();
  const { user } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    open: settingsOpen,
    openSettings,
    closeSettings,
  } = useSettingsDialog();
  const isMenuOpen = Boolean(anchorEl);

  const avatar = recruiter?.photo_url ?? recruiter?.logo_url;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAdminClick = (event) => {
    window.location.href = `${config.apiBaseUrl}/admin`;
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSettingsOpen = () => {
    handleClose();
    openSettings();
  };

  const handleManageBilling = async () => {
    handleClose();
    try {
      const url = await createPortalSession();
      window.location.href = url;
    } catch (err) {
      console.error("Failed to open billing portal:", err);
    }
  };

  return (
    <ProfileContainer>
      <IconButton
        id="user-menu-button"
        aria-controls={isMenuOpen ? "user-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={isMenuOpen ? "true" : undefined}
        onClick={handleClick}
      >
        <Avatar src={avatar} alt={recruiter?.user.name} />
      </IconButton>
      <ContextMenu
        id="user-menu"
        anchorEl={anchorEl}
        onClose={handleClose}
        labelledBy={"user-menu-button"}
      >
        <UserDetails>
          <strong>{recruiter?.user.name}</strong>
          <span>{recruiter?.user.email}</span>
        </UserDetails>
        {isAdmin && (
          <StyledMenuItem onClick={handleAdminClick}>Admin dashboard</StyledMenuItem>
        )}
        <StyledMenuItem onClick={handleSettingsOpen}>Settings</StyledMenuItem>
        {user?.hasBillingAccount && (
          <StyledMenuItem onClick={handleManageBilling}>Manage Billing</StyledMenuItem>
        )}
        <StyledMenuItem
          onClick={() => {
            handleClose();
            router.push("/integrations");
          }}
        >
          Integrations
        </StyledMenuItem>
        <StyledMenuItem onClick={logout}>Logout</StyledMenuItem>
      </ContextMenu>
      <Settings open={settingsOpen} onClose={closeSettings} />
    </ProfileContainer>
  );
}
